import type { ReactiveController, ReactiveControllerHost } from 'lit';
import { Subscription, type SubscriptionLike } from 'rxjs';

export abstract class UnsubscribableCtrl<T> implements ReactiveController {
  private _subscriptions: Subscription = new Subscription();

  constructor(protected _host: ReactiveControllerHost) {
    this._host.addController(this);
  }

  protected set _sub(sub: SubscriptionLike | undefined) {
    if (Boolean(sub)) {
      this._subscriptions.add(sub);
    }
  }

  public hostDisconnected(): void {
    this._subscriptions.unsubscribe();
  }

  protected _set<K extends keyof T>(key: K) {
    return <V extends T[K]>(value: V): void => {
      const that: T = this as any as T;
      that[key] = value;
      this._host.requestUpdate();
    };
  }
}
